import axios from 'axios';
import Immutable from "immutable";

const $URLSearchParams = obj => new URLSearchParams(Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))).toString()

export default {
  async getUsers() {
    const url = '/api/User/List';
    const response = await axios.get(url);
    return response.data;
  },
  async addUser(updateData) {
    /*if (!('language' in updateData) || !('pushNotificationsEnabled' in updateData)) {
      console.log('invalid data');
      return;
    }*/

    const _updateData = Immutable.fromJS(updateData).toJS();
    const data = {
      language: _updateData.language,
      pushNotificationsEnabled: _updateData.pushNotificationsEnabled,
      firstname: _updateData.firstname,
      lastname: _updateData.lastname,
      email: _updateData.email,
      vastuualueLinkit: [..._updateData.vastuualueLinkit]?.map(v => {
        v.vastuualue = null;
        return v;
      }),
      kayttajanOikeusToiseen: [..._updateData.kayttajanOikeusToiseen]?.map(u => {
        u.oikeusUser = null;
        return u;
      })
    };
    try {
      const response = await axios.post(`/api/User/`, data);
      return response.data;
    } catch (e) {
      console.error(e.response.data);
      throw new Error(e.response.data);
    }

  },
  async deleteUser(userId) {
    try {
      const response = await axios.delete(`/api/User/${userId}`);
      return response.data;
    } catch (e) {
      console.error(e.response.data);
      throw e.response.data;
    }
  },
  async updateUserSelf(userId, updateData) {
    /*if (!('language' in updateData) || !('pushNotificationsEnabled' in updateData)) {
      console.log('invalid data');
      return;
    }*/

    const data = {
      language: updateData.language,
      pushNotificationsEnabled: updateData.pushNotificationsEnabled,
      firstname: updateData.firstname,
      lastname: updateData.lastname,
      email: updateData.email,
    };
    const response = await axios.put(`/api/User/self`, data);
    return response.data;
  },
  async updateUser(userId, updateData) {
    /*if (!('language' in updateData) || !('pushNotificationsEnabled' in updateData)) {
      console.log('invalid data');
      return;
    }*/

    const _updateData = Immutable.fromJS(updateData).toJS();
    const data = {
      language: _updateData.language,
      pushNotificationsEnabled: _updateData.pushNotificationsEnabled,
      firstname: _updateData.firstname,
      lastname: _updateData.lastname,
      email: _updateData.email,
      vastuualueLinkit: [..._updateData.vastuualueLinkit]?.map(v => {
        v.vastuualue = null;
        return v;
      }),
      kayttajanOikeusToiseen: [..._updateData.kayttajanOikeusToiseen]?.map(u => {
        u.oikeusUser = null;
        return u;
      })
    };
    const response = await axios.put(`/api/User/` + userId, data);
    return response.data;
  },
  async getSystemData() {
    const url = '/api/System';
    const response = await axios.get(url);
    return response.data;
  },

  async getVastuualueet() {
    const url = '/api/Vastuualue';
    const response = await axios.get(url);
    return response.data;
  },

  async getVastuualueetFull() {
    const url = '/api/Vastuualue/full';
    const response = await axios.get(url);
    return response.data;
  },
  async getVastuualue(vastuualueId) {

    const url = '/api/Vastuualue/' + vastuualueId;
    const response = await axios.get(url);
    return response.data;
  },
  async createVastuualue(vastuualue) {
    const url = '/api/Vastuualue';
    const response = await axios({
      method: 'POST',
      data: vastuualue,
      url,

    })
    return response.data;
  },
  async updateVastuualue(vastuualue) {
    const url = '/api/Vastuualue/' + vastuualue.id;
    const response = await axios({
      method: 'PUT',
      data: vastuualue,
      url,
    })
    return response.data;
  },
  async deleteVastuualue(vastuualue) {
    const url = '/api/Vastuualue/' + vastuualue.id;
    const response = await axios({
      method: 'DELETE',
      url,
    })
    return response.data;
  },


  async getValinta(id) {
    const url = '/api/Valinta/' + id;
    const response = await axios.get(url);
    return response.data;
  },
  async getValinnat(vastuualue = null, vuosi = null) {
    let query = '';
    let params = {}
    if (vastuualue != null) {
      params.vastuualueId = vastuualue.id
    }
    if (vuosi != null) {
      params.vuosi = vuosi
    }
    query += '?' + new URLSearchParams(params);
    const url = '/api/Valinta' + query;
    const response = await axios.get(url);
    return response.data;
  },
  async createValinta(valinta) {
    const url = '/api/Valinta';
    const response = await axios({
      method: 'POST',
      data: valinta,
      url,
    })
    return response.data;
  },
  async updateValinta(valinta) {
    const url = '/api/Valinta/' + valinta.id;
    const response = await axios({
      method: 'PUT',
      data: valinta,
      url,
    })
    return response.data;
  },
  async deleteValinta(valinta) {
    const url = '/api/Valinta/' + valinta.id;
    const response = await axios({
      method: 'DELETE',
      url,
    })
    return response.data;
  },
  async copyValinnat(copyObject) {
    const url = '/api/Valinta/copy';
    const response = await axios({
      method: 'POST',
      data: copyObject,
      url,
    })
    return response.data;
  },


  async getValintatyypit(vastuualue = null) {
    let query = '';
    if (vastuualue != null) {
      query += '?' + $URLSearchParams({vastuualueId: vastuualue.id});
    }
    const url = '/api/Valintatyyppi' + query;
    const response = await axios.get(url);
    return response.data;
  },
  async createValintatyyppi(valintatyyppi) {
    const url = '/api/Valintatyyppi';
    const response = await axios({
      method: 'POST',
      data: valintatyyppi,
      url,
    })
    return response.data;
  },
  async updateValintatyyppi(valintatyyppi) {
    const url = '/api/Valintatyyppi/' + valintatyyppi.id;
    const response = await axios({
      method: 'PUT',
      data: valintatyyppi,
      url,
    })
    return response.data;
  },
  async deleteValintatyyppi(valintatyyppi) {
    const url = '/api/Valintatyyppi/' + valintatyyppi.id;
    const response = await axios({
      method: 'DELETE',
      url,
    })
    return response.data;
  },

  async getTehtava(id) {
    const url = '/api/Tehtava/' + id;
    const response = await axios.get(url);
    return response.data;
  },
  async getTehtavat(vastuualueId = null, valintaId = null, vuosi = null) {
    let query = '';

    query += '?' + $URLSearchParams({
      vastuualueId: vastuualueId,
      valintaId: valintaId,
      vuosi: vuosi
    });

    const url = '/api/Tehtava' + query;
    const response = await axios.get(url);
    return response.data;
  },
  async getTehtavaPisteet(vastuualueId, vuosi) {
    const url = `/api/Tehtava/pisteet/${vastuualueId}/${vuosi}`;
    const response = await axios.get(url);
    return response.data;
  },
  async createTehtava(tehtava) {
    const url = '/api/Tehtava';
    const response = await axios({
      method: 'POST',
      data: tehtava,
      url,
    })
    return response.data;
  },
  async updateTehtava(tehtava) {
    const url = '/api/Tehtava/' + tehtava.id;
    const response = await axios({
      method: 'PUT',
      data: tehtava,
      url,
    })
    return response.data;
  },
  async deleteTehtava(tehtava) {
    const url = '/api/Tehtava/' + tehtava.id;
    const response = await axios({
      method: 'DELETE',
      url,
    })
    return response.data;
  },
  async getTehtavaLinkit(tehtavaId) {
    const url = '/api/Tehtava/link/' + tehtavaId;
    const response = await axios.get(url);
    return response.data;
  },

  async addTehtavaLinkki(tehtavaId, tehtavaLiittyyId) {
    const url = '/api/Tehtava/link/' + tehtavaId + '/' + tehtavaLiittyyId;
    const response = await axios.post(url);
    return response.data;
  },
  async deleteTehtavaLinkki(tehtavaId, tehtavaLiittyyId) {
    const url = '/api/Tehtava/link/' + tehtavaId + '/' + tehtavaLiittyyId;
    const response = await axios.delete(url);
    return response.data;
  },

  async getTehtavaHenkiloLinkit(tehtavaId) {
    const url = '/api/Tehtava/henkilolink/' + tehtavaId;
    const response = await axios.get(url);
    return response.data;
  },
  async addTehtavaHenkiloLinkki(tehtavaId, userId) {
    const url = '/api/Tehtava/henkilolink/' + tehtavaId + '/' + userId;
    const response = await axios.post(url);
    return response.data;
  },
  async deleteTehtavaHenkiloLinkki(tehtavaId, userId) {
    const url = '/api/Tehtava/henkilolink/' + tehtavaId + '/' + userId;
    const response = await axios.delete(url);
    return response.data;
  },

  async getKommentit(body) {
    const url = '/api/Kommentti?' + new URLSearchParams(body).toString();
    const response = await axios.get(url);
    return response.data;
  },
  async createKommentti(kommentti) {
    const url = '/api/Kommentti';
    const response = await axios({
      method: 'POST',
      data: kommentti,
      url,
    })
    return response.data;
  },
  async updateKommentti(kommentti) {
    const url = '/api/Kommentti/' + kommentti.id;
    const response = await axios({
      method: 'PUT',
      data: kommentti,
      url,
    })
    return response.data;
  },
  async deleteKommentti(kommentti) {
    const url = '/api/Kommentti/' + kommentti.id;
    const response = await axios({
      method: 'DELETE',
      url,
    })
    return response.data;
  },

  async getUlkopuolinenLinkit(tehtavaId) {
    const url = '/api/Tehtava/urllink/' + tehtavaId;
    const response = await axios.get(url);
    return response.data;
  },

  async addUlkopuolinenLinkki(tehtavaId, linkki) {
    const url = '/api/Tehtava/urllink/' + tehtavaId;
    const response = await axios({
      url,
      method: 'POST',
      data: linkki
    });
    return response.data;
  },
  async updateUlkopuolinenLinkki(tehtavaId, id, linkki) {
    const url = '/api/Tehtava/urllink/' + tehtavaId + '/' + id;
    const response = await axios({
      url,
      method: 'PUT',
      data: linkki
    });
    return response.data;
  },
  async deleteUlkopuolinenLinkki(tehtavaId, id) {
    const url = '/api/Tehtava/urllink/' + tehtavaId + '/' + id;
    const response = await axios.delete(url);
    return response.data;
  },

  async getUserObjects(userId, vuosi) {
    const url = '/api/User/UserObjects/' + userId + '?vuosi=' + vuosi;
    const response = await axios.get(url);
    return response.data;
  }
};
